module.exports = __webpack_public_path__ + "img/portrait-027.324fa94c.jpg";